import {Component, Inject, input, signal, WritableSignal} from '@angular/core';
import {Widget, WidgetDataTable} from '../../models/dashboard';
import {TableModule} from 'primeng/table';
import {NgForOf} from '@angular/common';

@Component({
    selector: 'app-widget-template-table',
    imports: [
        TableModule,
        NgForOf
    ],
    templateUrl: './widget-template-table.component.html',
    styleUrl: './widget-template-table.component.css',
    standalone: true
})
export class WidgetTemplateTableComponent {
  widgetHeader: WritableSignal<string> = signal('');
  tableData;


  constructor(@Inject('contentData') public contentData: any, @Inject('label') public label: string) {
    this.tableData = signal<WidgetDataTable>(JSON.parse(this.contentData));
    this.widgetHeader.set(this.label);
  }

}
